module.exports = __webpack_public_path__ + "img/lucahub.2d25ecb0.png";